import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, ChangeDetectionStrategy, Directive, ViewChild, Input, NgModule, ContentChild } from '@angular/core';
import { CommonModule } from '@angular/common';

//istanbul ignore next
class AjaxLoaderComponent {
    ngOnInit() {
        // init
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AjaxLoaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AjaxLoaderComponent, selector: "[data-uxd-ajax-loader-cmp]", ngImport: i0, template: `<div>
                  <div class="ant-ui-widget-overlay"></div>
                  <div class="ant-ajax-load" >
                    <div class="sk-spinner sk-spinner-wave ant-ajax-spin">
                      <div class="sk-rect1"></div>
                      <div class="sk-rect2"></div>
                      <div class="sk-rect3"></div>
                      <div class="sk-rect4"></div>
                      <div class="sk-rect5"></div>
                    </div>
                    <ng-content class="ant-ajax-text"></ng-content>
                  </div>
                </div>`, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AjaxLoaderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: '[data-uxd-ajax-loader-cmp]',
                    template: `<div>
                  <div class="ant-ui-widget-overlay"></div>
                  <div class="ant-ajax-load" >
                    <div class="sk-spinner sk-spinner-wave ant-ajax-spin">
                      <div class="sk-rect1"></div>
                      <div class="sk-rect2"></div>
                      <div class="sk-rect3"></div>
                      <div class="sk-rect4"></div>
                      <div class="sk-rect5"></div>
                    </div>
                    <ng-content class="ant-ajax-text"></ng-content>
                  </div>
                </div>`
                }]
        }] });

//istanbul ignore next
class DateLoaderComponent {
    ngOnInit() {
        // init
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DateLoaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: DateLoaderComponent, selector: "[data-uxd-data-loader-cmp]", ngImport: i0, template: `<div>
                <div class="ant-data-load" >
                  <div class="sk-spinner sk-spinner-wave ant-data-spin">
                    <div class="sk-rect1"></div>
                    <div class="sk-rect2"></div>
                    <div class="sk-rect3"></div>
                    <div class="sk-rect4"></div>
                    <div class="sk-rect5"></div>
                  </div>
                  <div class="ant-data-text"><ng-content></ng-content></div>
                </div>
              </div>`, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DateLoaderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: '[data-uxd-data-loader-cmp]',
                    template: `<div>
                <div class="ant-data-load" >
                  <div class="sk-spinner sk-spinner-wave ant-data-spin">
                    <div class="sk-rect1"></div>
                    <div class="sk-rect2"></div>
                    <div class="sk-rect3"></div>
                    <div class="sk-rect4"></div>
                    <div class="sk-rect5"></div>
                  </div>
                  <div class="ant-data-text"><ng-content></ng-content></div>
                </div>
              </div>`
                }]
        }] });

class SpinnerComponent {
    constructor() {
        // constructor
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SpinnerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: SpinnerComponent, selector: "uxd-spinner, ant-spinner", ngImport: i0, template: "<div class=\"ant-loading-wrapper\">\n  <div class=\"motif-spinner-heart\">\n    <span></span>\n    <span></span>\n    <span></span>\n    <span></span>\n    <span></span>\n    <span></span>\n    <span></span>\n  </div>\n</div>", styles: ["@keyframes slideDown{0%{top:0%;bottom:100%;opacity:0}5%{top:0%;bottom:0%}12%{opacity:1}50%{top:0%;bottom:0%;opacity:1}55%{top:0%;bottom:100%}62%{opacity:0}to{top:0%;bottom:100%;opacity:0%}}@keyframes slideUp{0%{top:100%;bottom:0%;opacity:0}5%{top:0%;bottom:0%}12%{opacity:1}50%{top:0%;bottom:0%}55%{top:100%;bottom:0%;opacity:1}62%{opacity:0}to{top:100%;bottom:0%}}.ant-loading-wrapper{display:flex;justify-content:center;align-items:center;width:160px;height:100%;margin:50% auto}.ant-loading-wrapper .motif-spinner-heart{display:flex;padding:10px;height:120px}.ant-loading-wrapper .motif-spinner-heart span{position:relative;background:#eee;width:8px;display:flex;margin:4px;border-radius:4px;height:80px;top:25px}.ant-loading-wrapper .motif-spinner-heart span:nth-child(2n):before{animation:slideUp 5s ease-out infinite}.ant-loading-wrapper .motif-spinner-heart span:nth-child(odd):before{animation:slideDown 5s ease-out infinite}.ant-loading-wrapper .motif-spinner-heart span:nth-child(2):before{animation-delay:.286s}.ant-loading-wrapper .motif-spinner-heart span:nth-child(3):before{animation-delay:.572s}.ant-loading-wrapper .motif-spinner-heart span:nth-child(4):before{animation-delay:.858s}.ant-loading-wrapper .motif-spinner-heart span:nth-child(5):before{animation-delay:1.144s}.ant-loading-wrapper .motif-spinner-heart span:nth-child(6):before{animation-delay:1.43s}.ant-loading-wrapper .motif-spinner-heart span:nth-child(7):before{animation-delay:1.716s}.ant-loading-wrapper .motif-spinner-heart span:nth-child(1),.ant-loading-wrapper .motif-spinner-heart span:nth-child(7){height:30px;top:20px}.ant-loading-wrapper .motif-spinner-heart span:nth-child(2),.ant-loading-wrapper .motif-spinner-heart span:nth-child(6){height:60px;top:10px}.ant-loading-wrapper .motif-spinner-heart span:nth-child(3),.ant-loading-wrapper .motif-spinner-heart span:nth-child(5){height:80px;top:10px}.ant-loading-wrapper .motif-spinner-heart span:nth-child(odd):before{content:\"\";position:absolute;left:0;right:0;background:linear-gradient(0deg,#2ab5ca,#0079c2);border-radius:4px;top:0%}.ant-loading-wrapper .motif-spinner-heart span:nth-child(2n):before{content:\"\";position:absolute;left:0;right:0;background:linear-gradient(180deg,#2ab5ca,#0079c2);border-radius:4px;bottom:0%}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SpinnerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'uxd-spinner, ant-spinner', template: "<div class=\"ant-loading-wrapper\">\n  <div class=\"motif-spinner-heart\">\n    <span></span>\n    <span></span>\n    <span></span>\n    <span></span>\n    <span></span>\n    <span></span>\n    <span></span>\n  </div>\n</div>", styles: ["@keyframes slideDown{0%{top:0%;bottom:100%;opacity:0}5%{top:0%;bottom:0%}12%{opacity:1}50%{top:0%;bottom:0%;opacity:1}55%{top:0%;bottom:100%}62%{opacity:0}to{top:0%;bottom:100%;opacity:0%}}@keyframes slideUp{0%{top:100%;bottom:0%;opacity:0}5%{top:0%;bottom:0%}12%{opacity:1}50%{top:0%;bottom:0%}55%{top:100%;bottom:0%;opacity:1}62%{opacity:0}to{top:100%;bottom:0%}}.ant-loading-wrapper{display:flex;justify-content:center;align-items:center;width:160px;height:100%;margin:50% auto}.ant-loading-wrapper .motif-spinner-heart{display:flex;padding:10px;height:120px}.ant-loading-wrapper .motif-spinner-heart span{position:relative;background:#eee;width:8px;display:flex;margin:4px;border-radius:4px;height:80px;top:25px}.ant-loading-wrapper .motif-spinner-heart span:nth-child(2n):before{animation:slideUp 5s ease-out infinite}.ant-loading-wrapper .motif-spinner-heart span:nth-child(odd):before{animation:slideDown 5s ease-out infinite}.ant-loading-wrapper .motif-spinner-heart span:nth-child(2):before{animation-delay:.286s}.ant-loading-wrapper .motif-spinner-heart span:nth-child(3):before{animation-delay:.572s}.ant-loading-wrapper .motif-spinner-heart span:nth-child(4):before{animation-delay:.858s}.ant-loading-wrapper .motif-spinner-heart span:nth-child(5):before{animation-delay:1.144s}.ant-loading-wrapper .motif-spinner-heart span:nth-child(6):before{animation-delay:1.43s}.ant-loading-wrapper .motif-spinner-heart span:nth-child(7):before{animation-delay:1.716s}.ant-loading-wrapper .motif-spinner-heart span:nth-child(1),.ant-loading-wrapper .motif-spinner-heart span:nth-child(7){height:30px;top:20px}.ant-loading-wrapper .motif-spinner-heart span:nth-child(2),.ant-loading-wrapper .motif-spinner-heart span:nth-child(6){height:60px;top:10px}.ant-loading-wrapper .motif-spinner-heart span:nth-child(3),.ant-loading-wrapper .motif-spinner-heart span:nth-child(5){height:80px;top:10px}.ant-loading-wrapper .motif-spinner-heart span:nth-child(odd):before{content:\"\";position:absolute;left:0;right:0;background:linear-gradient(0deg,#2ab5ca,#0079c2);border-radius:4px;top:0%}.ant-loading-wrapper .motif-spinner-heart span:nth-child(2n):before{content:\"\";position:absolute;left:0;right:0;background:linear-gradient(180deg,#2ab5ca,#0079c2);border-radius:4px;bottom:0%}\n"] }]
        }], ctorParameters: function () { return []; } });

class FileCardComponent {
    // tslint:disable-next-line: no-empty
    constructor() { }
    // tslint:disable-next-line: no-empty
    ngOnInit() { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FileCardComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FileCardComponent, selector: "ant-file-card", host: { classAttribute: "ant-file-card" }, ngImport: i0, template: "<div class=\"ant-card-header\">\n  <div class=\"ant-file-icon-container\">\n    <ng-content select=\"file-icon, [file-icon], [fileicon]\"></ng-content>\n  </div>\n</div>\n<div class=\"ant-card-body\">\n  <div class=\"ant-card-content-flex\">\n    <div class=\"ant-card-header-title\">\n      <div class=\"ant-card-title\">\n        <ng-content select=\"file-title, [file-title], [fileTitle]\"></ng-content>\n      </div>\n      <div class=\"ant-card-subtitle\">\n        <ng-content select=\"file-subtitle, [file-subtitle], [fileSubtitle]\"></ng-content>\n      </div>\n    </div>\n    <ng-content select=\"[file-button], [fileButton]\"></ng-content>\n  </div>\n  <div class=\"ant-card-progress-bar\">\n    <ng-content select=\"file-upload-progress, [file-upload-progress], [fileUploadProgress]\"></ng-content>\n  </div>\n</div>\n", changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FileCardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ant-file-card', host: { class: 'ant-file-card' }, encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"ant-card-header\">\n  <div class=\"ant-file-icon-container\">\n    <ng-content select=\"file-icon, [file-icon], [fileicon]\"></ng-content>\n  </div>\n</div>\n<div class=\"ant-card-body\">\n  <div class=\"ant-card-content-flex\">\n    <div class=\"ant-card-header-title\">\n      <div class=\"ant-card-title\">\n        <ng-content select=\"file-title, [file-title], [fileTitle]\"></ng-content>\n      </div>\n      <div class=\"ant-card-subtitle\">\n        <ng-content select=\"file-subtitle, [file-subtitle], [fileSubtitle]\"></ng-content>\n      </div>\n    </div>\n    <ng-content select=\"[file-button], [fileButton]\"></ng-content>\n  </div>\n  <div class=\"ant-card-progress-bar\">\n    <ng-content select=\"file-upload-progress, [file-upload-progress], [fileUploadProgress]\"></ng-content>\n  </div>\n</div>\n" }]
        }], ctorParameters: function () { return []; } });

class FileTitleDirective {
    // tslint:disable-next-line: no-empty
    constructor() { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FileTitleDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FileTitleDirective, selector: "file-title, [file-title], [fileTitle]", host: { classAttribute: "ant-file-title" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FileTitleDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'file-title, [file-title], [fileTitle]',
                    host: {
                        class: 'ant-file-title'
                    }
                }]
        }], ctorParameters: function () { return []; } });
class FileSubtitleDirective {
    // tslint:disable-next-line: no-empty
    constructor() { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FileSubtitleDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FileSubtitleDirective, selector: "file-subtitle, [file-subtitle], [fileSubtitle]", host: { classAttribute: "ant-file-subtitle" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FileSubtitleDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'file-subtitle, [file-subtitle], [fileSubtitle]',
                    host: {
                        class: 'ant-file-subtitle'
                    }
                }]
        }], ctorParameters: function () { return []; } });
class FileiconDirective {
    // tslint:disable-next-line: no-empty
    constructor() { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FileiconDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FileiconDirective, selector: "file-icon, [file-icon], [fileIcon]", host: { classAttribute: "ant-file-icon" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FileiconDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'file-icon, [file-icon], [fileIcon]',
                    host: {
                        class: 'ant-file-icon'
                    }
                }]
        }], ctorParameters: function () { return []; } });
class FileButtonDirective {
    // tslint:disable-next-line: no-empty
    constructor() { }
    // tslint:disable-next-line: no-empty
    _handleOnFocus(event) { }
    // tslint:disable-next-line: no-empty
    _handleClick(event) { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FileButtonDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: FileButtonDirective, selector: "button[file-button], button[fileButton]", host: { listeners: { "click": "_handleClick($event)", "focus": "_handleOnFocus($event)" }, classAttribute: "ant-file-button" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FileButtonDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'button[file-button], button[fileButton]',
                    host: {
                        class: 'ant-file-button',
                        '(click)': '_handleClick($event)',
                        '(focus)': '_handleOnFocus($event)'
                    }
                }]
        }], ctorParameters: function () { return []; } });

class FileUploadProgressComponent {
    set percent(value) {
        if (value >= 0) {
            this._percent = value;
            this.moveProgressBar(value);
            this._changeDetector.detectChanges();
        }
    }
    get percent() {
        return this._percent;
    }
    constructor(_changeDetector) {
        this._changeDetector = _changeDetector;
        this._percent = -1;
    }
    ngAfterViewInit() {
        this._createChart();
        this.moveProgressBar(this.percent);
    }
    _createChart() {
        const element = this._chart.nativeElement;
        const barRect = d3
            .select(element)
            .append('svg')
            .attr('width', '100%')
            .attr('preserveAspectRatio', 'xMinYMin meet')
            .attr('viewBox', '0 0 140 10');
        barRect
            .append('rect')
            .attr('class', 'ant-rect-path')
            .attr('stroke', '#CCC')
            .attr('stroke-width', '2px')
            .attr('fill', '#EEE')
            .attr('x', 0)
            .attr('y', 0)
            .attr('rx', '3.5px')
            .attr('ry', '3.5px')
            .attr('height', '7px')
            .attr('width', '100%');
        this._progress = barRect
            .append('rect')
            .attr('class', 'progress-rect')
            .attr('fill', '#53b1a3')
            .attr('height', '7px')
            .attr('width', 0)
            .attr('rx', '3.5px')
            .attr('ry', '3.5px')
            .attr('x', 0);
    }
    moveProgressBar(percentage) {
        if (percentage < 0) {
            return;
        }
        const percent = `${percentage}%`;
        if (!this._progress) {
            return;
        }
        this._progress.transition().attr('width', percent);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FileUploadProgressComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FileUploadProgressComponent, selector: "file-upload-progress, [file-upload-progress], [fileUploadProgress]", inputs: { percent: "percent", ariaLabel: "ariaLabel", ariaLabelledBy: "ariaLabelledBy" }, viewQueries: [{ propertyName: "_chart", first: true, predicate: ["chart"], descendants: true, static: true }], ngImport: i0, template: `<div #chart></div>`, isInline: true, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FileUploadProgressComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'file-upload-progress, [file-upload-progress], [fileUploadProgress]',
                    template: `<div #chart></div>`,
                    encapsulation: ViewEncapsulation.None
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { _chart: [{
                type: ViewChild,
                args: ['chart', { static: true }]
            }], percent: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], ariaLabelledBy: [{
                type: Input
            }] } });

class FileSystemModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FileSystemModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FileSystemModule, declarations: [FileCardComponent, FileTitleDirective, FileSubtitleDirective, FileButtonDirective, FileUploadProgressComponent, FileiconDirective], imports: [CommonModule], exports: [FileCardComponent, FileTitleDirective, FileSubtitleDirective, FileButtonDirective, FileUploadProgressComponent, FileiconDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FileSystemModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FileSystemModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [FileCardComponent, FileTitleDirective, FileSubtitleDirective, FileButtonDirective, FileUploadProgressComponent, FileiconDirective],
                    exports: [FileCardComponent, FileTitleDirective, FileSubtitleDirective, FileButtonDirective, FileUploadProgressComponent, FileiconDirective]
                }]
        }] });

let uuid = 0;
class StepperHeadingComponent {
    constructor(_element) {
        this._element = _element;
    }
    ngAfterViewInit() {
        if (this._host && this._hostElement()) {
            this.id = this._hostElement().id;
        }
    }
    _host() {
        return this._element;
    }
    _hostElement() {
        if (!this._element) {
            throw Error('Host element does not exist in StepperHeadingComponent');
        }
        return this._element.nativeElement;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StepperHeadingComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: StepperHeadingComponent, selector: "[uxd-stepper-heading], [ant-stepper-heading]", host: { classAttribute: "ant-stepper-heading" }, ngImport: i0, template: `<ng-content></ng-content>`, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StepperHeadingComponent, decorators: [{
            type: Component,
            args: [{
                    selector: '[uxd-stepper-heading], [ant-stepper-heading]',
                    template: `<ng-content></ng-content>`,
                    host: {
                        class: 'ant-stepper-heading'
                    }
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; } });
class StepperStep {
    constructor(_element, _renderer) {
        this._element = _element;
        this._renderer = _renderer;
        this.state = 'inactive';
    }
    ngAfterViewInit() {
        const element = this._element.nativeElement;
        this._renderer.addClass(element, this.state);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StepperStep, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: StepperStep, selector: "[uxd-step], [ant-step]", inputs: { state: "state" }, host: { classAttribute: "ant-stepper__item" }, ngImport: i0, template: `
    <div class="stepper-icon"></div>
    <div class="stepper-label">
      <ng-content></ng-content>
    </div>
  `, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StepperStep, decorators: [{
            type: Component,
            args: [{
                    selector: '[uxd-step], [ant-step]',
                    template: `
    <div class="stepper-icon"></div>
    <div class="stepper-label">
      <ng-content></ng-content>
    </div>
  `,
                    host: {
                        class: 'ant-stepper__item'
                    }
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { state: [{
                type: Input
            }] } });
class StepperComponent {
    get id() {
        return this._id;
    }
    set id(id) {
        this._id = id;
    }
    // tslint:disable-next-line:no-empty
    constructor(_renderer) {
        this._renderer = _renderer;
        this.alignment = 'horizontal';
        this._id = `stepper-${uuid++}`;
    }
    ngAfterViewInit() {
        this.id = this.id;
        if (this.heading && !this.heading.id) {
            this.heading.id = `${this.id}__heading`;
        }
        this._renderer.addClass(this.parent.nativeElement, this.alignment);
    }
    _ariaLabelledBy() {
        const _headingId = this.heading ? this.heading.id : this._id;
        return `${_headingId}`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StepperComponent, deps: [{ token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: StepperComponent, selector: "uxd-stepper-cmp, ant-stepper-cmp", inputs: { alignment: "alignment" }, host: { classAttribute: "ant-stepper" }, queries: [{ propertyName: "heading", first: true, predicate: StepperHeadingComponent, descendants: true }], viewQueries: [{ propertyName: "parent", first: true, predicate: ["host"], descendants: true }], ngImport: i0, template: `
    <ol class="ant-stepper__container" #host [attr.aria-labelledby]="_ariaLabelledBy()" [id]="id + '-container'">
      <ng-content></ng-content>
    </ol>
  `, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StepperComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'uxd-stepper-cmp, ant-stepper-cmp',
                    template: `
    <ol class="ant-stepper__container" #host [attr.aria-labelledby]="_ariaLabelledBy()" [id]="id + '-container'">
      <ng-content></ng-content>
    </ol>
  `,
                    host: {
                        class: 'ant-stepper'
                    }
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }]; }, propDecorators: { parent: [{
                type: ViewChild,
                args: ['host']
            }], heading: [{
                type: ContentChild,
                args: [StepperHeadingComponent]
            }], alignment: [{
                type: Input
            }] } });

class IndicatorModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IndicatorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: IndicatorModule, declarations: [AjaxLoaderComponent, DateLoaderComponent, SpinnerComponent, StepperHeadingComponent, StepperComponent, StepperStep], imports: [CommonModule, FileSystemModule], exports: [AjaxLoaderComponent, DateLoaderComponent, SpinnerComponent, StepperHeadingComponent, StepperComponent, StepperStep, FileSystemModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IndicatorModule, imports: [CommonModule, FileSystemModule, FileSystemModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: IndicatorModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FileSystemModule],
                    declarations: [AjaxLoaderComponent, DateLoaderComponent, SpinnerComponent, StepperHeadingComponent, StepperComponent, StepperStep],
                    exports: [AjaxLoaderComponent, DateLoaderComponent, SpinnerComponent, StepperHeadingComponent, StepperComponent, StepperStep, FileSystemModule]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AjaxLoaderComponent, DateLoaderComponent, FileButtonDirective, FileCardComponent, FileSubtitleDirective, FileSystemModule, FileTitleDirective, FileUploadProgressComponent, FileiconDirective, IndicatorModule, SpinnerComponent, StepperComponent, StepperHeadingComponent, StepperStep };
